module.exports = __webpack_public_path__ + "img/p4-c1-p3.d40702c2.jpg";